import { showNetworkError } from 'platform-components';
import { all, call, put, race, select, take, takeLatest } from 'redux-saga/effects';

// @ts-ignore
import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { actions as lessonActions } from 'common.components/lesson';

import { actions as lessonWidgetActions } from './actions';

export function* lessonEditorWidgetWatcher() {
    yield all([takeLatest(lessonWidgetActions.startListen, startListenSaga)]);
}

// This actions listen only when component mounted
function* temporaryWatcher() {
    yield all([takeLatest(lessonActions.restoreCLessonSuccess, restoreLessonSaga)]);
}

function* startListenSaga() {
    yield race({
        tasks: call(temporaryWatcher),
        cancel: take(lessonWidgetActions.stopListen),
    });
}

export function* restoreLessonSaga(action: ReturnType<typeof lessonActions.restoreCLessonSuccess>) {
    const { cLessonId } = action.payload;

    yield call(showLessonWidget, cLessonId);
}

function* showLessonWidget(clessonId: number) {
    try {
        const courseId: number = yield select(getCurrentYearCourseId);

        // При восстановлении урока с виджета, а не со странички занятия, нет возможности получить courseId
        // т.к. отсутствует subject в урле
        if (courseId) {
            yield put(lessonActions.getFullClessonRequest({ clessonId, courseId }));
        }

        yield put(lessonWidgetActions.toggleLessonWidget(true));
    } catch (error) {
        console.error(error);
        yield put(showNetworkError(error));
    }
}
